import { Checkbox, LoaderIcon } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import type { VideoBroadcastWidgetState } from '../../../store/VideoBroadcastWidgetState';
import styles from '../../VideoBroadcastWidget.module.scss';

export const AdditionalInfo = observer(function AdditionalInfo({
  widgetState,
}: {
  widgetState: VideoBroadcastWidgetState;
}) {
  const { t } = useTranslation('videoBroadcastWidget', { useSuspense: false });
  const { camName, depthHole, depthBit } = widgetState.additionalInfo;

  return (
    <div className={styles.tooltipWrapper}>
      <div className={styles.tooltipTitle}>{t('sidebar.additionalInfo')}</div>
      {widgetState.isBaseParamsLoading || widgetState.wellboresLoading ? (
        <LoaderIcon size="s" />
      ) : (
        <ul className={styles.actionsList}>
          <li className={styles.actionsListItem}>
            <Checkbox initialValue={camName} onChange={(value) => widgetState.setAdditionalInfo({ camName: value })} />
            <span>{t('sidebar.broadcastName')}</span>
          </li>
          {widgetState.depthHoleCurveId && (
            <li className={styles.actionsListItem}>
              <Checkbox
                initialValue={depthHole}
                onChange={(value) => widgetState.setAdditionalInfo({ depthHole: value })}
              />
              <span>{t('sidebar.holeDepth')}</span>
            </li>
          )}

          {widgetState.depthBitCurveId && (
            <li className={styles.actionsListItem}>
              <Checkbox
                initialValue={depthBit}
                onChange={(value) => widgetState.setAdditionalInfo({ depthBit: value })}
              />
              <span>{t('sidebar.bitDepth')}</span>
            </li>
          )}
        </ul>
      )}
    </div>
  );
});
